// src/components/strategies/TradeDetailModal.jsx

import { HiX } from 'react-icons/hi';
import { useTranslation } from 'react-i18next'; // Импорт перевода

const formatDate = (timestamp, lang) => {
  if (!timestamp) return 'N/A';
  return new Date(timestamp).toLocaleString(lang === 'ru' ? 'ru-RU' : 'en-US', {
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit', second: '2-digit',
  }).replace(',', '');
};

const PnlValue = ({ value }) => (
    <span className={`font-mono text-lg font-semibold ${value >= 0 ? 'text-green-400' : 'text-red-400'}`}>
        {value?.toFixed(2) || '0.00'} $
    </span>
);

const TradeDetailModal = ({ trade, onClose, symbol_a, symbol_b }) => {
  const { t, i18n } = useTranslation(); // Инициализация
  if (!trade) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50 animate-fade-in-up"
      onClick={onClose}
    >
      <div
        className="bg-slate-800 rounded-xl shadow-2xl p-6 w-full max-w-4xl text-white border border-slate-700"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-bold">{t('trades.modal.title')}</h2>
          <button onClick={onClose} className="p-2 text-gray-400 rounded-full hover:bg-slate-700 hover:text-white">
            <HiX className="h-6 w-6" />
          </button>
        </div>

        <div className="space-y-6 max-h-[80vh] overflow-y-auto custom-scrollbar pr-2">
            {/* Секция входов */}
            <div className="space-y-4">
            <h3 className="text-lg font-semibold text-slate-300 border-b border-slate-700 pb-2">
                {t('trades.modal.entries_title')} ({trade.entries?.length || 0})
            </h3>
            <div className="space-y-3">
                {trade.entries?.map((entry, index) => (
                <div key={index} className="bg-slate-700/50 p-4 rounded-lg grid grid-cols-1 md:grid-cols-4 gap-4 text-sm">
                    <div className="font-semibold">
                    <span className="text-slate-400">{t('trades.modal.entry_num')}{index + 1}</span>
                    <p className="text-base text-white">{formatDate(entry.time, i18n.language)}</p>
                    </div>
                    <div>
                    <span className="text-slate-400 block">Z-Score / Level</span>
                    <span className="font-mono">{entry.z?.toFixed(4)} / {entry.level}</span>
                    </div>
                    <div className="font-mono">
                        <span className={`block ${entry.pos_a === 'LONG' ? 'text-green-400' : 'text-red-400'}`}>
                            {symbol_a} {entry.pos_a}
                        </span>
                        <p>{t('trades.modal.price')}: ${entry.price_a}</p>
                        <p>{t('trades.modal.qty')}: {entry.quantity_a?.toFixed(4)}</p>
                    </div>
                    <div className="font-mono">
                        <span className={`block ${entry.pos_b === 'LONG' ? 'text-green-400' : 'text-red-400'}`}>
                            {symbol_b} {entry.pos_b}
                        </span>
                        <p>{t('trades.modal.price')}: ${entry.price_b}</p>
                        <p>{t('trades.modal.qty')}: {entry.quantity_b?.toFixed(4)}</p>
                    </div>
                </div>
                ))}
            </div>
            </div>

            {/* Итоги сделки */}
            <div className="space-y-4">
                <h3 className="text-lg font-semibold text-slate-300 border-b border-slate-700 pb-2">
                    {t('trades.modal.exit_pnl_title')}
                </h3>
                <div className="bg-slate-700/50 p-4 rounded-lg grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 text-sm">
                    <div>
                        <span className="text-slate-400 block">{t('trades.modal.exit_price')} ({symbol_a})</span>
                        <span className="font-mono text-lg">${trade.exit_price_a?.toFixed(4) || 'N/A'}</span>
                    </div>
                    <div>
                        <span className="text-slate-400 block">{t('trades.modal.exit_price')} ({symbol_b})</span>
                        <span className="font-mono text-lg">${trade.exit_price_b?.toFixed(5) || 'N/A'}</span>
                    </div>
                    <div>
                        <span className="text-slate-400 block">{t('trades.modal.pnl_coin')} ({symbol_a})</span>
                        <PnlValue value={trade.pnl_a_usdt} />
                    </div>
                    <div>
                        <span className="text-slate-400 block">{t('trades.modal.pnl_coin')} ({symbol_b})</span>
                        <PnlValue value={trade.pnl_b_usdt} />
                    </div>
                    <div>
                        <span className="text-slate-400 block font-bold">{t('trades.modal.total_pnl')}</span>
                        <PnlValue value={trade.net_pnl_usdt} />
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
  );
};

export default TradeDetailModal;